<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Manager Management</h1>
    <userTable />
  </v-card>
</template>

<script>
import userTable from "@/components/back-office/ManagerUserManage/UserTable.vue";
import { mapState } from "vuex";
export default {
  components: {
    userTable,
  },
  computed: {
    ...mapState({
      recentPath: (state) => state.backOffice.recentRoutePath,
    }),
  },
  destroyed() {
    this.$store.commit("fetchUserBack/resetState");
  },
  methods: {
    async getData() {
      this.loadingMessage = true;
      await this.$store.dispatch("banklist/GetCountApproveBank");
      await this.$store.dispatch("cashRequest/fetchCountRequest");
      this.loadingMessage = false;
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Manager management",
        disabled: true,
        href: "/weserve_admin_login/control/-/manager-manage",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style></style>
